import { all } from "@redux-saga/core/effects";
import { metricDashboardSagas } from "modules/Metric/services/dashboard/sagas";
import {metricDataCollectionStatusSagas} from "modules/Metric/services/MetricDataCollectionStatus/sagas";
import {keywordScanStatsSagas} from "modules/Metric/services/MetricKeywordScanStats/sagas";

export function* metricSaga() {
    yield all([
        metricDashboardSagas(),
        metricDataCollectionStatusSagas(),
        keywordScanStatsSagas()
    ]);
}
